import React from 'react';
import { Empty } from 'antd';
import { SaleOrderItem } from 'models/SaleOrder';
import ProductItem from 'components/PurchaseOrder/ProductItem';
import { getFilePath } from 'utils';
import { useProductImagesMap } from 'hooks/useProductImagesMap';

interface ListSaleProductProps {
  products: SaleOrderItem[];
  disabled?: boolean;
  emptyText?: string;
  isQuickView?: boolean;
}

const ListSaleProduct: React.FC<ListSaleProductProps> = ({
  products,
  emptyText = 'Không có sản phẩm nào',
  isQuickView = false,
}) => {
  const productVersionIds = products ? (products.map((item) => item.productVersionId).filter(Boolean) as string[]) : [];
  // const [productItems, setProductItems] = useState<ProductData[]>([]);
  const { imagesMap: productImagesMap } = useProductImagesMap(productVersionIds);
  const getImageUrl = (productVersionId: string) => {
    const imagePaths = productImagesMap?.[productVersionId];
    return imagePaths && imagePaths.length > 0 ? getFilePath() + '/' + imagePaths[0] : undefined;
  };
  if (!products || products.length === 0) {
    return (
      <div className='flex flex-col'>
        {!isQuickView && (
          <div className='text-lg font-bold mb-4 text-[var(--textBlack)]'>DANH SÁCH SẢN PHẨM ĐÃ CHỌN</div>
        )}
        <Empty description={emptyText} className='my-4' />
      </div>
    );
  }

  return (
    <div
      className={
        'flex flex-col p-4 shadow-sm w-full ' +
        (!isQuickView ? 'bg-white rounded-[16px]' : 'bg-[var(--bgGreyColor)] rounded-b-lg')
      }
    >
      {!isQuickView && (
        <div className='text-lg font-bold mb-[36px] text-[var(--textBlack)]'>DANH SÁCH SẢN PHẨM ĐÃ CHỌN</div>
      )}
      <div className='flex flex-col gap-2 overflow-y-auto max-h-[500px] w-full'>
        {products?.map((item) => {
          return (
            <ProductItem
              key={item.id}
              id={item.id}
              name={item.name + ' ' + item.color + ' ' + item.productDimension}
              unitPrice={item.salePrice}
              quantity={item.quantity}
              imageUrl={getImageUrl(item.productVersionId)}
              currencyUnit={'VNĐ'}
              unit={item.unit || ''}
              attribute={item.attributeName || ''}
              atrtributePrice={item.attributePrice || 0}
              dimension={
                item.saleDimensions
                  ?.replaceAll('|', ' x ')
                  .replace(/\s*x\s*(?=x|$)/g, ' ')
                  .trim() || ''
              }
              isPOS
              isQuickView={true}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ListSaleProduct;
